// Re-export types from stores
export type { User } from '../stores/authStore';
export type { Notification } from '../stores/uiStore';

// Common API types
export interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  message?: string;
  error?: string | { code: string; message: string; details?: Record<string, unknown> };
}

export interface ApiError {
  message: string;
  code?: string;
  details?: Record<string, unknown>;
}

// Type guards for runtime validation
export function isApiSuccess<T>(obj: unknown): obj is ApiResponse<T> & { success: true; data: T } {
  return typeof obj === 'object' && obj !== null && 'success' in obj && (obj as any).success === true;
}

export function isApiError(obj: unknown): obj is ApiResponse & { success: false } {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'success' in obj &&
    (obj as any).success === false
  );
}

// Pagination types
export interface PaginationParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}

// Form types
export interface FormErrors {
  [key: string]: string | string[] | FormErrors;
}

// Common entity types
export interface BaseEntity {
  id: string;
  createdAt: string;
  updatedAt: string;
}

// Export members types
export * from './members';